import { render, staticRenderFns } from "./driversIndex.vue?vue&type=template&id=45d71966&"
import script from "./driversIndex.vue?vue&type=script&lang=js&"
export * from "./driversIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports